import React, {Component} from 'react';
import autobind from 'autobind-decorator';
import {Col, Row} from 'react-bootstrap';

import {service as EnvironmentalBenefitService} from '../../../Services/EnvironmentalBenefitService';
import {service as PermissionService} from '../../../Services/PermissionService';
import {StreamBankEditableCheckerEnhance} from "../../../Components/Common/Enhancements/StreamBankEditableCheckerEnhance";

import {MutableList} from "../../../Components/Common/MutableList";
import {Glyphicon} from "../../../Components/Common/GlyphIcon";
import {HelpIcon} from "../../../Components/Common/HelpIcon";

export class StreamBankMutableList extends MutableList {
    @autobind
    canAddNewEntry() {
        const { Editable } = this.props;

        return Editable;
    }

    render() {
        const { className, Type, GetItemKey, GetTitle = null, GetSubTitle = null, AddItem, UpdateItem, RemoveItem, Editable, DataTypeName, AdditionalTypeProps } = this.props;

        let extraClassName = "";
        if(className) {
            extraClassName = className;
        }

        return (
            <div className={"sb-mutable-list-override-container " + extraClassName}>
                { this.props.children }
                {
                    this.getData() ?
                        this.getData().map((x) =>
                            <Col key={GetItemKey(x)} className="sb-mutable-list-item-section"
                                 xs={12}>
                                    {
                                        Editable ?
                                            <Row className="sb-mutable-list-remove-section">
                                                <a className="pndlm-remove-control" onClick={() => RemoveItem(GetItemKey(x))}>
                                                    <Glyphicon glyph="remove-sign" />
                                                </a>
                                            </Row> :
                                            null
                                    }
                                    <Type
                                        Key={GetItemKey(x)}
                                        Item={x}
                                        UpdateItem={(value) => UpdateItem(GetItemKey(x), value)}
                                        {...AdditionalTypeProps}
                                        title={GetTitle?.(x)}
                                        subtitle={GetSubTitle?.(x)}
                                    />
                            </Col>
                        ) :
                        null
                }
                {
                    this.canAddNewEntry() ?
                        <Col xs={12} className="sb-mutable-list-add-section" onClick={() => AddItem()}>
                            <a>
                                <Glyphicon glyph="plus-sign" />Add {DataTypeName}
                            </a>
                        </Col>
                        :
                        null
                }
            </div>
        );
    }
}

export class StreamBankProgramEnvBenefitsMutableList extends StreamBankMutableList {
    constructor(props) {
        super(props);

        this.state = {
            environmentalBenefits: []
        };
    }

    componentDidMount() {
        EnvironmentalBenefitService.Get()
            .then(environmentalBenefits => {
                this.setState({environmentalBenefits: environmentalBenefits?.result || []})
            });
    }

    @autobind
    canAddNewEntry() {
        const { environmentalBenefits } = this.state || {};
        const { Data } = this.props;

        //if we don't have any more Benefit Types. Lets disable the add new button.
        if(Data?.length >= environmentalBenefits?.length) {
            return false;
        }

        return super.canAddNewEntry();
    }
}

export class StreamBankSpeciesListMutableList extends MutableList {
    constructor(props) {
        super(props);

        // TODO: Fix this SB-2045
        // Emitter.Subscribe(APP_SPECIES_LIST_CHANNEL, (x) => {
        //     this.props.AddItem(x)
        // });
    }
}

export class NoHeaderStreamBankMutableList extends Component {
    render() {
        return (
            <StreamBankMutableList
                className="sb-mutable-list-override-container-no-header"
                {...this.props}
            />
        );
    }
}

export class NoHeaderStreamBankImmutableList extends Component {
    render() {
        return (
            <NoHeaderStreamBankMutableList
                {...this.props}
                Editable={false}
            />
        );
    }
}

export class InnerStreamBankMutableList extends Component {
    render() {
        return (
            <StreamBankMutableList
                className="sb-mutable-list-override-container-inner sb-mutable-list-override-container-no-header row"
                {...this.props}
            />
        );
    }
}

export class StreamBankTagMutableList extends MutableList {
    render() {
        return (
            <div>
                { this.props.children }
                {
                    this.getData() ?
                        this.getData().map((x) =>
                            <Row key={this.props.GetItemKey(x)} className="pop-row">
                                <div className="pop-col">
                                    <this.props.Type
                                        Key={this.props.GetItemKey(x)}
                                        Item={x}
                                        UpdateItem={(value) => this.props.UpdateItem(this.props.GetItemKey(x), value)}
                                        {...this.props.AdditionalTypeProps}
                                    />
                                </div>
                                {
                                    this.props.Editable && !x.isAssigned ?
                                        <div className="remove-table pop-remove">
                                            <a className="pndlm-remove-control" onClick={() => this.props.RemoveItem(this.props.GetItemKey(x))}>
                                                <Glyphicon glyph="remove-sign" />
                                            </a>
                                        </div> :
                                        <div className="remove-table pop-remove">
                                            <HelpIcon id={"help-icon-" + x.fileUploadTagId}>
                                                This tag has been auto-assigned and cannot be removed.
                                            </HelpIcon>
                                        </div>
                                }
                            </Row>
                        ) :
                        null
                }
                {
                    this.props.Editable ?
                        <Row className="pop-row">
                            <div className="float-right add-table pop-add">
                                <a className="pndlm-remove-control" onClick={() => this.props.AddItem()}>
                                    <Glyphicon glyph="plus-sign" />
                                </a>
                            </div>
                        </Row> :
                        null
                }
            </div>
        );
    }
}

export class StreamBankUserPermissionList extends MutableList {
    constructor(props) {
        super(props);

        this.state = {
            permissions: []
        };
    }

    componentDidMount() {
        PermissionService.GetPermissions('user')
            .then(x => {
                this.setState({permissions: x.result || []})
            });
    }

    @autobind
    update(key, value) {
        if (!key) {
            const {userId, permissionId} = value;

            this.props.AddItem({userId, permissionId});
        } else {
            this.props.RemoveItem(key)
        }
    }

    render() {
        return (
            <div>
                {
                    this.state.permissions.map((permission) => {
                        const data = this.getData() ?? [];
                        const userPermission = data.find(x => x.permissionId === permission.permissionId);
                        const itemKey = userPermission ? this.props.GetItemKey(userPermission) : null;
                        permission.value = 0;
                        permission.userId = this.props.AdditionalTypeProps?.RootData?.userId;

                        if (userPermission) {
                            permission.value = 1;
                        }

                        // we can't use GetItemKey here because it is tied to
                        // the model of the association (UserPermission) and
                        // looks for permission.userPermissionId instead so
                        // instead I've hard-coded these keys which should
                        // match the permissionId instead
                        return <Row key={permission.permissionId} className="pop-row">
                            <div className="pop-col">
                                <this.props.Type
                                    Key={permission.permissionId}
                                    Item={permission}
                                    UpdateItem={(value) => this.update(itemKey, value)}
                                    {...this.props.AdditionalTypeProps}
                                />
                            </div>
                        </Row>
                    })
                }
            </div>
        );
    }
}

@StreamBankEditableCheckerEnhance
export class StreamBankProjectStakeholderList extends MutableList {
    @autobind
    isEditable(x) {
        if (!this.props.Editable) {
            return false;
        }

        // new ProjectStakeholderRelationships don't have contextNodeIds
        // but we should allow the user to edit them
        if (!x.contextNodeId) {
            return true;
        }

        return this.props.EditableChecker.CanEditContextNodeId(x.contextNodeId);
    }

    render() {
        return (
            <div>
                { this.props.children }
                {
                    this.getData() ?
                        this.getData().map((x) =>
                            <Row key={this.props.GetItemKey(x)} className="pop-row">
                                <div className={`pop-col ${!this.isEditable(x) ? 'view-mode' : ''}`}>
                                    <this.props.Type
                                        Key={this.props.GetItemKey(x)}
                                        Item={x}
                                        UpdateItem={(value) => this.props.UpdateItem(this.props.GetItemKey(x), value)}
                                        {...this.props.AdditionalTypeProps}
                                        Editable={this.isEditable(x)}
                                    />
                                </div>
                                {
                                    this.isEditable(x) ?
                                        <div className="remove-table pop-remove">
                                            <a className="pndlm-remove-control" onClick={() => this.props.RemoveItem(this.props.GetItemKey(x))}>
                                                <Glyphicon glyph="remove-sign" />
                                            </a>
                                        </div> :
                                        null
                                }
                            </Row>
                        ) :
                        null
                }
                {
                    this.props.Editable ?
                        <Row className="pop-row">
                            <div className="float-right add-table pop-add">
                                <a className="pndlm-remove-control" onClick={() => this.props.AddItem()}>
                                    <Glyphicon glyph="plus-sign" />
                                </a>
                            </div>
                        </Row> :
                        null
                }
            </div>
        );
    }
}

// export class StreamBankModeledUpliftSampleList extends MutableList {
//     constructor(props) {
//         super(props);
//
//         const { HasPermission, HasAnyPermission } = this.props;
//         const { user, lastNonAdminUrl } = this.state || {};
//
//         const hasPermissionsTab = HasAnyPermission(['update_organization', 'create_user', 'can_update_survey']);
//         const hasSpeciesTab = HasPermission('can_view_species_list');
//
//         const { organization } = Emitter.GetMostRecentMessage(USER_CONTEXT_CHANNEL);
//
//         let sampleModels = [
//             ModeledUpliftBeforeSample,
//             ModeledUpliftAfterSample,
//         ];
//
//         if(organization.code === 'ipc') {
//             sampleModels = [
//                 ModeledUpliftSample,
//             ];
//         }
//
//
//
//         this.state = {
//             metricDescriptorCache: {},
//             sampleModels: sampleModels
//         };
//
//         MetricDescriptorService.Get({metricDescriptorName: '/ModeledUplift/'})
//
//     .then((y) => {
//             //save what we pulled into the state.
//             let clone = ObjectUtils.Clone(this.state.metricDescriptorCache);
//             clone[x.metricDescriptorId] = y.result;
//             this.setState({metricDescriptorCache: clone});
//         });
//     }
//
//     @autobind
//     getData() {
//         let ret = super.getData();
//
//         //sort data by metric descriptors if we have them. If not the php will save these as we expect.
//         if(ret?.length) {
//             for(let i = 0; i < ret.length; i++) {
//                 let x = ret[i];
//
//                 //if we have a metric descriptor lets ensure the cache has it, or lets get it from the cache.
//                 if(x.metricDescriptorId) {
//                     if(!this.state.metricDescriptorCache[x.metricDescriptorId]) {
//                         //Pull from ajax
//                         MetricDescriptorService.Get(x.metricDescriptorId).then((y) => {
//                             //save what we pulled into the state.
//                             let clone = ObjectUtils.Clone(this.state.metricDescriptorCache);
//                             clone[x.metricDescriptorId] = y.result;
//                             this.setState({metricDescriptorCache: clone});
//                         });
//                     }
//
//                     //if we have metric ids.
//                     ret.sort((x, y) => {
//                         if(x.metricDescriptorId && y.metricDescriptorId) {
//                             let a = this.state.metricDescriptorCache[x.metricDescriptorId];
//                             let b = this.state.metricDescriptorCache[y.metricDescriptorId];
//
//                             if(a && b) {
//                                 if(a.path.endsWith("Before")) {
//                                     return -1;
//                                 } else if (b.path.endsWith("Before")) {
//                                     return 1;
//                                 } else if(a.path.endsWith("After")) {
//                                     return 1;
//                                 } else if (b.path.endsWith("After")) {
//                                     return -1;
//                                 }
//                             }
//                         }
//
//                         return 0;
//                     });
//                 }
//             }
//         }
//
//         return ret;
//     }
//
//     @autobind
//     getMetricDescriptionForSampleModel(sampleModel) {
//
//
//
//     }
//
//     render() {
//         let extraClassName = "";
//         if(this.props.className) {
//             extraClassName = this.props.className;
//         }
//
//         //if we don't have 2 records. Let's keep adding.
//         let data = this.getData();
//         if(!data || data.length < this.state.sampleModels.length) {
//
//
//
//             let nextSampleModel = this.state.sampleModels[data.length];
//
//             MetricDescriptorService.Get({metricDescriptorName: '' + benefitName + '/ModeledUpfift'}).then((result) => {
//
//
//                 let metricDescriptorId = result.result.metricDescriptorId;
//
//                 this.props.AddItem({metricDescriptorId: metricDescriptorId});
//
//             });
//
//
//
//             // don't bother rendering
//             // AddItem will cause a re-render
//             return null;
//         }
//
//         let counter = 0;
//         return (
//             <div className={"sb-mutable-list-override-container-no-header sb-mutable-list-override-container " + extraClassName}>
//                 {
//                     data ?
//                         data.map((x) => {
//                             let additionalTypeProps = ObjectUtils.DeepClone(this.props.AdditionalTypeProps);
//
//                             if(counter < this.state.sampleModels.length) {
//                                 additionalTypeProps.FieldDef.model = new this.state.sampleModels[counter]();
//                             } else {
//                                 return null;
//                             }
//
//                             counter++;
//                             return <Row key={this.props.GetItemKey(x)}>
//                                 <Col xs={12}>
//                                     <this.props.Type
//                                         Key={this.props.GetItemKey(x)}
//                                         Item={x}
//                                         UpdateItem={(value) => this.props.UpdateItem(this.props.GetItemKey(x), value)}
//                                         {...additionalTypeProps}
//                                     />
//                                 </Col>
//                             </Row>;
//                         }) :
//                         null
//                 }
//             </div>
//         );
//     }
// }
